import {
  initializeFirebase,
  getFirebaseAnalytics,
  logEvent,
  getString
} from './javascript-fire-base.js';

const sections = {
  "2.0": [
    "plans-hero",
  ],
  "1.0": [
    "plans-hero-b",
  ],
  "all": [
    "real-customer-stories",
    "shop-with-confidence",
    "reviews",
    "faq"
  ]
}

async function initializePlansPageLayout() {
  try {
    const { firebaseRemoteConfig } = await initializeFirebase();

    // const activePageVersion = getString(firebaseRemoteConfig, "plans_page_version_2");
    // alert(`Active Page Version: ${activePageVersion}`);
    const activePageVersion = "1.0"; // Hardcoded for testing purposes

    Object.keys(sections).forEach(version => {
      if (version !== activePageVersion && version !== "all") {
        sections[version].forEach(section => {
          const sectionElement = document.getElementById(section);
          if (sectionElement) {
            sectionElement.style.display = "none";
          }
        });
      }
    });

    sections[activePageVersion].forEach(section => {
      const sectionElement = document.getElementById(section);
      if (sectionElement) {
        sectionElement.style.opacity = "1";
      }
    });

    sections["all"].forEach(section => {
      const sectionElement = document.getElementById(section);
      if (sectionElement) {
        sectionElement.style.opacity = "1";
      }
    });

    window.scrollTo(0, 0);
    return activePageVersion;
  } catch (error) {
    console.error("Error fetching remote config, using defaults:", error);

    const latestVersion = Object.keys(sections).filter(version => version !== "all").sort().pop();

    Object.keys(sections).forEach(version => {
      if (version !== latestVersion && version !== "all") {
        sections[version].forEach(section => {
          const sectionElement = document.getElementById(section);
          if (sectionElement) {
            sectionElement.style.display = "none";
          }
        });
      }
    });

    sections[latestVersion].forEach(section => {
      const sectionElement = document.getElementById(section);
      if (sectionElement) {
        sectionElement.style.opacity = "1";
      }
    });

    sections["all"].forEach(section => {
      const sectionElement = document.getElementById(section);
      if (sectionElement) {
        sectionElement.style.opacity = "1";
      }
    });

    window.scrollTo(0, 0);
    return latestVersion;
  }
}

document.addEventListener('DOMContentLoaded', async () => {
  const primaryCTAs = document.querySelectorAll('.primary-cta');

  const activePageVersion = await initializePlansPageLayout();

  primaryCTAs.forEach(cta => {
    cta.addEventListener('click', () => {
      logEvent(getFirebaseAnalytics(), 'primary_cta_click', {
        source: 'plans_page',
        page_version: activePageVersion
      });
    });
  });
})
